import { IPaymentTemplateEventsService } from '@app/logic/payment-template-events/IPaymentTemplateEventsService';
import { Injectable, Injector } from '@angular/core';
import { HttpWrapperService } from '@app/core/services/http-wrapper/http-wrapper.service';
import { map, Observable } from 'rxjs';
import { INumberId } from '@app/shared/interfaces/i.number-id';
import { BaseLogicService } from '@app/logic/base/base-logic.service';
import { IPaymentTemplateEventDto } from '@classictechsolutions/hubapi-transpiled-enums';
import {
    IPaymentTemplateEventsMapped
} from '@app/logic/payment-template-events/interfaces/i.payment-template-events.mapped';
import { PaymentTemplateEventsMapped } from '@app/logic/payment-template-events/payment-template-events.mapped';

@Injectable({
    providedIn: 'root'
})
export class PaymentTemplateEventsService extends BaseLogicService<IPaymentTemplateEventDto, IPaymentTemplateEventsMapped> implements IPaymentTemplateEventsService {

    constructor(
        protected readonly $http: HttpWrapperService,
        protected readonly $injector: Injector
    ) {
        super(
            'paymenttemplateevents',
            PaymentTemplateEventsMapped
        );
    }

    public saveSortOrder(events: INumberId[]): Observable<IPaymentTemplateEventsMapped[]> {
        const payload = events.map(x => ({ id: x.id }));

        return this.$http
            .post<Array<IPaymentTemplateEventDto>>(`${this.$baseUri}/savesortorder`, payload)
            .pipe(
                map(items => items.map(x => this.$createMappedItem(x)))
            );
    }

}
